import Dialog from "@/components/Dialog";
import Button from "@/components/Button";
import classNames from "classnames";

interface ArchiveGovernanceRoleDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  personName?: string;
  facilityName?: string;
  roleLabel?: string;
}

export function ArchiveGovernanceRoleDialog({
  open,
  onClose,
  onConfirm,
  isLoading = false,
  personName = "this person",
  facilityName,
  roleLabel
}: ArchiveGovernanceRoleDialogProps) {
  return (
    <Dialog
      open={open}
      onClosed={onClose}
      headline="Archive Governance Role"
      actions={
        <>
          <Button variant="text" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isLoading}
            theme="error"
            icon={isLoading ? "progress_activity" : "archive"}
            iconClassName={classNames(isLoading && "animate-spin w-6 h-6 !block")}
            trailingIcon={false}
            testId="confirm-archive-governance-role"
          >
            Archive
          </Button>
        </>
      }
    >
      <p>
        {facilityName ? (
          <>
            Are you sure you want to archive {roleLabel ? `the ${roleLabel} role` : "this governance role"} at{" "}
            {facilityName}? Archived roles are removed from the active list.
          </>
        ) : (
          <>
            Are you sure you want to archive {personName}
            {roleLabel ? `'s ${roleLabel} role` : "'s governance role"} at this facility? Archived roles are removed
            from the active list.
          </>
        )}
      </p>
    </Dialog>
  );
}
